import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

interface ReopenWebsiteCheckConfirmationProps {
    open: boolean;
    onClose: () => void;
    onReopen: () => void;
}

const ReopenWebsiteCheckConfirmation = (props: ReopenWebsiteCheckConfirmationProps) => {
    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>
                Website-Check erneut öffnen
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Möchten Sie den Website-Check wirklich erneut öffnen? Die Daten können anschließend wieder
                    bearbeitet werden, bis der Website-Check erneut eingereicht wird.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>
                    Abbrechen
                </Button>
                <Button color={'primary'} onClick={props.onReopen} variant={'contained'}>
                    Erneut öffnen
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReopenWebsiteCheckConfirmation;
